<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">Limited Partners
                <span class="card-subtitle" v-if="investor.name">{{investor.name}} ({{investor.cp_email}})</span>
                <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/investors')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">{{trans('investor.investor_list')}}</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <investor-sidebar menu="data-matching" :id="id"></investor-sidebar>
                                <div class="col-9 col-sm-9">
                                    <h4 class="card-title">Data matching</h4>
                                    <div class="table-responsive" v-if="transcripts.total">
                                      <table class="table table-hover">
                                        <thead>
                                        <tr>
                                          <th scope="col">{{trans('transcript.held_at')}}</th>
                                          <th scope="col">{{trans('transcript.title')}}</th>
                                          <th scope="col">{{trans('transcript.participants')}}</th>
                                          <th scope="col" class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="transcript in transcripts.data">
                                          <td style="white-space:nowrap;">{{ transcript.held_at | momentDateTime }}</td>
                                          <td v-text="transcript.title"></td>
                                          <td style="max-width:500px;" class="pta-transcript-participants" v-html="transcript.speakers">
                                            <!-- <span v-for="participant in transcript.participants">{{ participant.email }}</span> -->
                                          </td>
                                          <td class="table-option">
                                            <div class="btn-group">
                                              <router-link :to="`/account/transcripts/${transcript.id}/meeting-minutes`" class="btn btn-info btn-sm" v-tooltip="trans('transcript.view_meeting_minutes')"><i class="fa-light fa-screen-users"></i></router-link>
                                              <router-link :to="`/account/transcripts/${transcript.id}`" class="btn btn-info btn-sm" v-tooltip="'Data'"><i class="fa-light fa-scroll"></i></router-link>
                                            </div>
                                          </td>
                                        </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <p v-else>No Transcripts for matching available.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import investorSidebar from './investor-sidebar'

    export default {
        components : { investorSidebar},
        data() {
            return {
                id:this.$route.params.id,
              transcripts: {
                total: 0,
                data: []
              },
                investorForm: new Form({
                    name: '',
                    cp_first_name: '',
                    cp_last_name: '',
                    cp_email: ''
                },false),
                filterTranscriptForm: {
                  title: '',
                  speaker: '',
                  sort_by : 'held_at',
                  order: 'desc',
                  page_length: 100,
                  investor_id: 0
                },
                investor: ''               
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/investors');
            }
            this.fetchInvestorData();
          this.getTranscripts();
        },
        methods: {
          getTranscripts(page){
            if (typeof page !== 'number') {
              page = 1;
            }
            this.filterTranscriptForm.investor_id = this.id;
            let url = helper.getFilterURL(this.filterTranscriptForm);
            axios.get('/api/transcript?page=' + page + url)
                .then(response => response.data)
                .then(response => {
                  this.transcripts = response;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
            fetchInvestorData(){
                axios.get('/api/investor/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.investor = response.investor;
                        this.investorForm.cp_first_name = response.investor.cp_first_name;
                        this.investorForm.cp_last_name = response.investor.cp_last_name;
                        this.investorForm.cp_email = response.investor.cp_email;
                        this.investorForm.name = response.investor.name;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/investor');
                    })
            },
            /*  submit(){
                this.investorForm.date_of_birth = (this.investorForm.date_of_birth) ? moment(this.investorForm.date_of_birth).format('YYYY-MM-DD') : null;
                this.investorForm.date_of_anniversary = (this.investorForm.date_of_anniversary) ? moment(this.investorForm.date_of_anniversary).format('YYYY-MM-DD') : null;
                this.investorForm.patch('/api/investor/'+this.id)
                    .then(response => {
                        this.fetchInvestorData();
                        toastr.success(response.message);
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }, */
        },
      filters: {
        moment(date) {
          return helper.formatDate(date);
        },
        momentDateTime(date) {
          return helper.formatDateTime(date);
        }
      }
    }
</script>
